export const matterForBusinessProductCards = [
	{
		icon: '🖼',
		title: 'matterForBusinessData_title1',
		subtitle: 'matterForBusinessData_subtitle1',
	},
	{
		icon: '✨',
		title: 'matterForBusinessData_title2',
		subtitle: 'matterForBusinessData_subtitle2',
	},
	{
		icon: '💁‍♀️',
		title: 'matterForBusinessData_title3',
		subtitle: 'matterForBusinessData_subtitle3',
	},
	{
		icon: '🤘',
		title: 'matterForBusinessData_title4',
		subtitle: 'matterForBusinessData_subtitle4',
	},
];
